/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { investmentNeedFundingCardDtoSchema } from "./investmentNeedFundingCardDtoSchema.ts";
import { z } from "zod/v4";

export const investmentNeedFundingHistoryDtoSchema = z.object({
  get dilutive() {
    return investmentNeedFundingCardDtoSchema.nullish();
  },
  get nonDilutive() {
    return investmentNeedFundingCardDtoSchema.nullish();
  },
});
